export default [
  {
    name: 'vehicle-expenses',
    path: '/vehicles/expenditure',
    component: () => import('@/views/vehicles/expenses/VehicleExpenses')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeVehicleExpenses.js